import { getAccessToken } from '@/utils/tokenStorage'

export function supportIdAtArm(pairs: { replies?: { id?: string; kind?: string }[] }[]): string | null {
  let armed: string | null = null
  for (const pair of pairs) {
    for (const reply of pair.replies || []) {
      if (reply.kind === 'support_text' && reply.id) armed = reply.id
    }
  }
  return armed
}

export function isArmedSupport(messageId: string | undefined, armedId: string | null): boolean {
  return Boolean(messageId && armedId && messageId === armedId)
}

export function openHelpZettelStream(
  conversationId: string,
  zettelId: string,
  onMessage: (data: { tts?: boolean; more?: boolean; live?: boolean; message_id?: string; text?: string; status?: string; seq?: number }) => void,
): () => void {
  const ac = new AbortController()
  const token = getAccessToken()
  const headers: Record<string, string> = { Accept: 'text/event-stream' }
  if (token) headers.Authorization = `Bearer ${token}`
  void fetch(`/api/v1/help/${conversationId}/zettel/${zettelId}/stream`, {
    headers,
    credentials: 'include',
    signal: ac.signal,
  }).then(async (res) => {
    if (!res.ok || !res.body) return
    const reader = res.body.getReader()
    const dec = new TextDecoder()
    let buf = ''
    while (true) {
      const chunk = await reader.read()
      if (chunk.done) break
      buf += dec.decode(chunk.value, { stream: true })
      const parts = buf.split('\n\n')
      buf = parts.pop() || ''
      for (const block of parts) {
        for (const line of block.split('\n')) {
          if (!line.startsWith('data: ')) continue
          try {
            onMessage(JSON.parse(line.slice(6)) as { tts?: boolean; message_id?: string; text?: string; status?: string })
          } catch { /* ignore */ }
        }
      }
    }
  }).catch(() => {})
  return () => ac.abort()
}
